'use client'

import { Button, Col, Row, Typography, Icon } from '@repo/ui/components'
import { useTranslate } from '@repo/shared/hooks'
import { ToDateTime } from '@repo/shared/components'
import { useIsDesktop } from '@repo/ui/hooks'
import { UserUserMessage, useUserInboxMarkAsRead } from '@repo/services'

export const MessageItem = ({ message }: { message: UserUserMessage }) => {
  const { t } = useTranslate()

  const { mutate: markAsRead } = useUserInboxMarkAsRead({
    invalidate: true,
  })
  const isDesktop = useIsDesktop()

  const handleRead = () => {
    markAsRead({
      msgID: message.id,
    })
  }
  const isRead = message.readAt && message.readAt !== '0001-01-01T00:00:00Z'
  return (
    <Col
      className='pb-md first:pt-lg gap-md border-b border-neutral-surface-5 last:border-none'
      onClick={isDesktop ? handleRead : undefined}
      buttonClassName='text-start items-start gap-xs'
    >
      {/* Header with timestamp and status */}
      <Row className='justify-between'>
        <Row className=' gap-xs items-center'>
          {!isRead && (
            <div
              className={
                isRead
                  ? 'w-2 h-2 rounded-full bg-transparent '
                  : 'w-2 h-2 rounded-full bg-negative-main'
              }
            />
          )}
          <Typography size='xs' color='text-neutral-surface-60'>
            <ToDateTime date={new Date(message.createdAt ?? '')} />
          </Typography>
        </Row>

        {!isDesktop && !isRead && (
          <Button
            variant='transparent'
            size='sm'
            color='base'
            onClick={handleRead}
          >
            {t('profileMessagesPage_read_messages_item')}
          </Button>
        )}
      </Row>

      {/* Message content */}
      <Typography
        size='sm'
        color='text-neutral-surface-100'
        className='text-start '
      >
        {message.body?.format}
      </Typography>

      {/* Call to action button */}
      {message.meta?.action && (
        <Row className='justify-end'>
          <Button
            variant='ghost'
            size='xs'
            color='base'
            // onClick={message.meta.action.url}
            endIcon={<Icon name='ArrowLeftLine' size='sm' />}
          >
            {message.meta.action.key}
          </Button>
        </Row>
      )}
    </Col>
  )
}
